import styled from 'styled-components';

import { Label as BasicLabel } from '../../styles';
import { NewStyleColor } from '../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../utils/style';

interface FileLabelProps {
	isImporting: boolean;
}

const FileLabelWrapper = styled('div')`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 20px 0;
	padding: 10px;
	border-radius: 6px;
	background-color: ${hexToRgba(NewStyleColor.White, 10)};

	button {
		flex: 0 0 20px;
		margin-left: 15px;
	}
`;

const FileLabelInner = styled('div')`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex: 1 1 auto;
	height: 50px;
	padding: 0;
	border-radius: 4px;
	background-color: ${hexToRgba(NewStyleColor.White, 25)};
	overflow: hidden;
`;

const FileLabel = styled('span')`
	width: 100%;
	font-family: HelveticaNeue, sans-serif;
	font-size: 14px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	${({ isImporting }: FileLabelProps) => isImporting && `
		&::after {
			content: '...';
		}
	`}
`;

const Icon = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 50px;
	height: 50px;

	svg {
		width: 24px;
		height: 24px;
		fill: ${hexToRgba(NewStyleColor.White, 75)};
	}
`;

const PopupBody = styled('div')`
	padding: 20px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
	text-align: center;
`;

const CheckboxWrapper = styled('div')`
	margin-top: 20px;

	label {
		color: ${NewStyleColor.Blue450};

		span {
			font-size: 16px;
			color: ${hexToRgba(NewStyleColor.White, 75)};
		}
	}
`;

const Label = styled(BasicLabel)`
	margin-top: 20px;
	padding-left: 0;
`;

export {
	FileLabelWrapper,
	FileLabelInner,
	FileLabel,
	Icon,
	Label,
	PopupBody,
	CheckboxWrapper,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SettingsPanel/PdfSettingsPanel/styles.ts